import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9511d89a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table-part" }
const _hoisted_2 = { class: "state" }
const _hoisted_3 = ["title"]
const _hoisted_4 = ["title"]
const _hoisted_5 = { class: "table-btn" }
const _hoisted_6 = ["onClick"]

import Title from "@/components/Title.vue";
import ApproveFilter from "@/components/ApproveFilter.vue";
import { APPLY } from "../../const/openManageTableList.ts";
import { getApplylList } from "../../api/approve";

import { ref, reactive, onMounted, onActivated } from "vue";

import { useRoute, useRouter } from "vue-router";
import { message } from "ant-design-vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const tableData = ref([]);
const pagination = reactive({
  total: 0,
  current: 1,
  defaultPageSize: 10,
  pageSize: 10,
  showQuickJumper: true,
  showSizeChanger: true,
  pageSizeOptions: ["5", "10", "20", "30", "40"],
  showTotal: (total: number) => `共 ${total} 条数据`,
});

const router = useRouter();
const route = useRoute();
const data = reactive({
  filterForm: {
    Key: "",
    RegionId: 0,
    CompanyId: 0,
    ApproveNode: 0,
    ApprovalMatters: 0,
    Approves: -1,
    CompanyType: 0,
    ExpectOpenStartTime: "",
    ExpectOpenEndTime: "",
    LocationId: "",
    ApplyTimeArr: [],
  },
});
const getProcessFlowList = async () => {
  const { Data, Success, Message, Total } = await getApplylList({
    ApproveNode: data.filterForm.ApproveNode,
    ApprovalMatters: data.filterForm.ApprovalMatters,
    Approves: data.filterForm.Approves,
    PageIndex: pagination.current,
    PageSize: pagination.pageSize,
    CompanyId: data.filterForm.CompanyId,
    RegionId: data.filterForm.RegionId,
    Key: data.filterForm.Key,
    CompanyType: data.filterForm.CompanyType || 0,
    ExpectOpenStartTime: data.filterForm.ExpectOpenStartTime,
    ExpectOpenEndTime: data.filterForm.ExpectOpenEndTime,
    LocationId: data.filterForm.LocationId,
    ApplyStartTime: data.filterForm.ApplyTimeArr
      ? data.filterForm.ApplyTimeArr[0]
      : "",
    ApplyEndTime: data.filterForm.ApplyTimeArr
      ? data.filterForm.ApplyTimeArr[1]
      : "",
  });
  if (Success) {
    Data.length > 0 &&
      Data.forEach((item: any) => {
        if (item.ApproveStaffName.includes(";")) {
          item.ApproveStaffName = item.ApproveStaffName.substring(
            0,
            item.ApproveStaffName.indexOf(";")
          );
        }
      });
    tableData.value = Data;
    pagination.total = Total;
  } else {
    message.warning(Message);
  }
};

// getProcessFlowList();
// 判断页面是从相关二级页面 返回
onActivated(() => {
  if (route.meta.flag) {
    //  保留筛选条件
  } else {
    data.filterForm = {
      Key: "",
      RegionId: 0,
      CompanyId: 0,
      ApproveNode: 0,
      ApprovalMatters: 0,
      Approves: -1,
      CompanyType: 0,
      ExpectOpenStartTime: "",
      ExpectOpenEndTime: "",
      LocationId: "",
      ApplyTimeArr: [],
    };
    pagination.current = 1;
    pagination.pageSize = 10;
  }

  getProcessFlowList();
});
// 数据筛选
const DataSearch = (val) => {
  data.filterForm = val;
  pagination.current = 1;
  getProcessFlowList();
};
const handleTableChange = (row) => {
  pagination.current = row.current;
  pagination.pageSize = row.pageSize;
  getProcessFlowList();
};
// 详情
const handleDetail = (row: string) => {
  const ApprovalMatters = "1";
  const Id = row.Id;
  const IsCreated = row.IsCreated;
  if (IsCreated) {
    // 是否是创建人 1 是 0 否
    router.push({
      path: "/open",
      // query: {
      //   type: ApprovalMatters,
      //   id: Id,
      //   tableFlag: "isFromApplyTable",
      // },
    });
  } else {
    router.push({
      path: "/signsure/detail",
      query: {
        type: ApprovalMatters,
        id: Id,
        tableFlag: "isFromApplyTable",
      },
    });
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Title, { title: '申请列表' }),
    _createVNode(ApproveFilter, {
      titleFlag: '申请列表',
      onDataSearch: DataSearch
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_table, {
        columns: _unref(APPLY),
        "data-source": tableData.value,
        pagination: _unref(pagination),
        scroll: { x: 1000 },
        onChange: handleTableChange
      }, {
        constatus: _withCtx(({ text: state, record }) => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: _normalizeClass([
              state === '已通过'
                ? 'cricle-go'
                : state === '已驳回'
                ? 'cricle-reject'
                : state === '已撤销'
                ? 'cricle-back'
                : 'cricle',
            ])
            }, null, 2),
            _createElementVNode("div", {
              class: _normalizeClass([
              state === '已通过'
                ? 'state-go'
                : state === '已驳回'
                ? 'state-reject'
                : state === '已撤销'
                ? 'state-back'
                : 'state',
            ]),
              title: 
              state +
              (record.ApproveStaffName && state !== '已通过'
                ? '(' +
                  (record.ApproveStaffName.includes(';')
                    ? record.ApproveStaffName.substring(
                        0,
                        record.ApproveStaffName.indexOf(';')
                      )
                    : record.ApproveStaffName) +
                  ')'
                : '')
            
            }, _toDisplayString(state +
              (record.ApproveStaffName && state !== "已通过"
                ? "(" +
                  (record.ApproveStaffName.includes(";")
                    ? record.ApproveStaffName.substring(
                        0,
                        record.ApproveStaffName.indexOf(";")
                      )
                    : record.ApproveStaffName) +
                  ")"
                : "")), 11, _hoisted_3)
          ])
        ]),
        ApproveStaffName: _withCtx(({ text: state }) => [
          _createElementVNode("span", { title: state }, _toDisplayString(state.includes(";") ? state.substring(0, state.indexOf(";")) : state), 9, _hoisted_4)
        ]),
        btn: _withCtx(({ text: record }) => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              class: "btnClass",
              onClick: ($event: any) => (handleDetail(record))
            }, "详情", 8, _hoisted_6)
          ])
        ]),
        _: 1
      }, 8, ["columns", "data-source", "pagination"])
    ])
  ], 64))
}
}

})